import {
  useGetAverageReceiptAkcLazyQuery,
  useGetAverageReceiptToLazyQuery,
  useGetCarAverageDailyMileageByMonthLazyQuery,
  useGetCarForeignForServiceByMonthByCarModelLazyQuery,
  useGetCarForeignForServiceByMonthLazyQuery,
  useGetCarForeignForServiceByPeriodByCarModelLazyQuery,
  useGetCarForeignForServiceByPeriodLazyQuery,
  useGetCarForeignForServiceGibddByMonthLazyQuery,
  useGetCarForeignForServiceGibddByPeriodLazyQuery,
  useGetCarForServiceByMonthByCarModelRegionLazyQuery,
  useGetCarForServiceByMonthLazyQuery,
  useGetCarForServiceByPeriodConsolidatedLazyQuery,
  useGetCarForServiceByPeriodLazyQuery,
  useGetCarForServiceGibddByMonthLazyQuery,
  useGetCarForServiceGibddByPeriodLazyQuery,
  useGetCarServiceByDealerLazyQuery,
  useGetCarServiceDynamicsLazyQuery,
  useGetClientsWithoutServiceLazyQuery,
  useGetInviteClientToServiceLazyQuery,
  useGetLoyaltyServiceByDealerLazyQuery,
  useGetLoyaltyServiceLazyQuery,
  useGetNsByAverageCarAgeLazyQuery,
  useGetNsByClientCarSaleLazyQuery,
  useGetNsByClientLazyQuery,
  useGetNsByConsultantLazyQuery,
  useGetNsByDealerLazyQuery,
  useGetNsByOldClientsLazyQuery,
  useGetNsByWarmClientsLazyQuery,
  useGetReportInviteClientToServiceLazyQuery,
  useGetReportReturnCarAverageDailyMileageByMonthLazyQuery,
  useGetReportReturnCarForAgoByMonthLazyQuery,
  useGetReportReturnCarForeignForAgoByMonthLazyQuery,
  useGetReportReturnCarForeignForServiceByMonthByCarModelLazyQuery,
  useGetReportReturnCarForeignForServiceByMonthLazyQuery,
  useGetReportReturnCarForeignForServiceByPeriodByCarModelLazyQuery,
  useGetReportReturnCarForeignForServiceByPeriodLazyQuery,
  useGetReportReturnCarForeignForServiceGibddByMonthLazyQuery,
  useGetReportReturnCarForeignForServiceGibddByPeriodLazyQuery,
  useGetReportReturnCarForServiceByMonthByCarModelRegionLazyQuery,
  useGetReportReturnCarForServiceByMonthLazyQuery,
  useGetReportReturnCarForServiceByPeriodConsolidatedLazyQuery,
  useGetReportReturnCarForServiceByPeriodLazyQuery,
  useGetReportReturnCarForServiceGibddByMonthLazyQuery,
  useGetReportReturnCarForServiceGibddByPeriodLazyQuery,
  useGetReportReturnCarServiceByDealerLazyQuery,
  useGetReportReturnCarServiceDynamicsLazyQuery,
  useGetReportReturnClientsWithoutServiceLazyQuery,
  useGetReportReturnSrr3ByCarLazyQuery,
  useGetReportReturnSrr3ByDealerLazyQuery,
  useGetReportReturnSrr3ByPeriodLazyQuery,
  useGetReportReturnSrr3ByVinLazyQuery,
  useGetReportReturnSrr3ForPaymentsLazyQuery,
  useGetReportReturnSrr5ByCarLazyQuery,
  useGetReportReturnSrr5ByPeriodLazyQuery,
  useGetReportReturnSrr5ByVinLazyQuery,
  useGetReportReturnSrr5ForPaymentsLazyQuery,
  useGetReturnCarForAgoByMonthLazyQuery,
  useGetReturnCarForeignForAgoByMonthLazyQuery,
  useGetSrr3ByCarLazyQuery,
  useGetSrr3ByDealerLazyQuery,
  useGetSrr3ByPeriodLazyQuery,
  useGetSrr3ByVinLazyQuery,
  useGetSrr3ForPaymentsLazyQuery,
  useGetSrr3GibddByDealerLazyQuery,
  useGetSrr3GibddByPeriodLazyQuery,
  useGetSrr5ByCarLazyQuery,
  useGetSrr5ByDealerLazyQuery,
  useGetSrr5ByPeriodLazyQuery,
  useGetSrr5ByVinLazyQuery,
  useGetSrr5ForPaymentsLazyQuery,
  useGetSrr5GibddByDealerLazyQuery,
  useGetSrr5GibddByPeriodLazyQuery,
  useGetUniqueServiceLazyQuery,
  useReportAverageReceiptAkcLazyQuery,
  useReportAverageReceiptToLazyQuery,
  useReportNsByAverageCarAgeLazyQuery,
  useReportNsByClientCarSaleLazyQuery,
  useReportNsByClientLazyQuery,
  useReportNsByConsultantLazyQuery,
  useReportNsByDealerLazyQuery,
  useReportNsByOldClientsLazyQuery,
  useReportNsByWarmClientsLazyQuery,
  useReportReturnLoyaltyServiceByDealerLazyQuery,
  useReportReturnLoyaltyServiceLazyQuery,
  useReportReturnSrr3GibddByDealerLazyQuery,
  useReportReturnSrr3GibddByPeriodLazyQuery,
  useReportReturnSrr5ByDealerLazyQuery,
  useReportReturnSrr5GibddByDealerLazyQuery,
  useReportReturnSrr5GibddByPeriodLazyQuery,
  useReportReturnUniqueServiceLazyQuery,
} from "~/schemas/generated/graphql";

type TSrrLazyHook = (options?: any) => [(opts?: any) => void, any];

export interface ISrrVariablesSpec {
  baseFrom?: boolean;
  groupKey?: "group" | "groupReport";
  monthControl?: boolean;
  salePeriod?: boolean;
  periodRange?: "period" | "periodOptional" | "salePeriod";
  car?: boolean;
  familyCar?: boolean;
  typeClient?: boolean;
  dealerIdsKey?: "dealerIds" | "DealerIds";
  numberGO?: boolean;
  lifetime?: boolean;
  kindReport?: boolean;
  kinds?: boolean;
  nsDealerExtras?: boolean;
  nsExtras?: boolean;
  invitation?: boolean;
}

export interface ISrrReportConfigEntry {
  table: {
    hook: TSrrLazyHook;
    getterPath: string;
    defaultArray?: boolean;
  };
  export: {
    hook: TSrrLazyHook;
    getterPath: string;
  };
  variables: {
    excel: ISrrVariablesSpec;
    table: ISrrVariablesSpec;
  };
  tableHasRefetchOnCompleted: boolean;
}

const MONTH_CONTROL = (
  groupKey: "group" | "groupReport",
): ISrrVariablesSpec => ({
  baseFrom: true,
  groupKey,
  monthControl: true,
  salePeriod: true,
});

const SALES_PERIOD = (
  groupKey: "group" | "groupReport",
  car?: boolean,
): ISrrVariablesSpec => ({
  baseFrom: true,
  groupKey,
  periodRange: "salePeriod",
  car,
});

const PERIOD_GROUP: ISrrVariablesSpec = {
  baseFrom: true,
  groupKey: "group",
  periodRange: "period",
};

const TC_MONTH: ISrrVariablesSpec = { typeClient: true, monthControl: true };

const PERIOD_TC: ISrrVariablesSpec = {
  periodRange: "period",
  typeClient: true,
};

const NS_EXTRAS: ISrrVariablesSpec = {
  baseFrom: true,
  periodRange: "period",
  familyCar: true,
  nsExtras: true,
};

export const SRR_REPORTS_CONFIG: Record<string, ISrrReportConfigEntry> = {
  ReportReturnUniqueService: {
    table: {
      hook: useGetUniqueServiceLazyQuery,
      getterPath: "SRRGetter.getUniqueService",
    },
    export: {
      hook: useReportReturnUniqueServiceLazyQuery,
      getterPath: "SRRGetter.reportReturnUniqueService",
    },
    variables: {
      excel: {
        baseFrom: true,
        groupKey: "group",
        periodRange: "periodOptional",
        kindReport: true,
        kinds: true,
        familyCar: true,
        typeClient: true,
      },
      table: {
        baseFrom: true,
        groupKey: "group",
        periodRange: "periodOptional",
        kindReport: true,
        kinds: true,
        familyCar: true,
      },
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnLoyaltyService: {
    table: {
      hook: useGetLoyaltyServiceLazyQuery,
      getterPath: "SRRGetter.getLoyaltyService",
    },
    export: {
      hook: useReportReturnLoyaltyServiceLazyQuery,
      getterPath: "SRRGetter.reportReturnLoyaltyService",
    },
    variables: {
      excel: {
        baseFrom: true,
        groupKey: "group",
        periodRange: "periodOptional",
        kindReport: true,
        kinds: true,
        familyCar: true,
        typeClient: true,
      },
      table: {
        baseFrom: true,
        groupKey: "group",
        periodRange: "periodOptional",
        kindReport: true,
        kinds: true,
        familyCar: true,
      },
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnLoyaltyServiceByDealer: {
    table: {
      hook: useGetLoyaltyServiceByDealerLazyQuery,
      getterPath: "SRRGetter.getLoyaltyServiceByDealer",
    },
    export: {
      hook: useReportReturnLoyaltyServiceByDealerLazyQuery,
      getterPath: "SRRGetter.reportReturnLoyaltyServiceByDealer",
    },
    variables: {
      excel: { periodRange: "period", kinds: true, familyCar: true },
      table: { periodRange: "period", kinds: true, familyCar: true },
    },
    tableHasRefetchOnCompleted: false,
  },
  TOMonthOfControlMine: {
    table: {
      hook: useGetCarForServiceByMonthLazyQuery,
      getterPath: "SRRGetter.getCarForServiceByMonth",
    },
    export: {
      hook: useGetReportReturnCarForServiceByMonthLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForServiceByMonth",
    },
    variables: {
      excel: MONTH_CONTROL("groupReport"),
      table: MONTH_CONTROL("group"),
    },
    tableHasRefetchOnCompleted: true,
  },
  TOMonthOfControlFriendOrFoe: {
    table: {
      hook: useGetCarForeignForServiceByMonthLazyQuery,
      getterPath: "SRRGetter.getCarForeignForServiceByMonth",
    },
    export: {
      hook: useGetReportReturnCarForeignForServiceByMonthLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForeignForServiceByMonth",
    },
    variables: {
      excel: MONTH_CONTROL("groupReport"),
      table: MONTH_CONTROL("group"),
    },
    tableHasRefetchOnCompleted: true,
  },
  TOMonthOfControlFriendOrFoeByCarFamily: {
    table: {
      hook: useGetCarForeignForServiceByMonthByCarModelLazyQuery,
      getterPath: "SRRGetter.getCarForeignForServiceByMonthByCarModel",
    },
    export: {
      hook: useGetReportReturnCarForeignForServiceByMonthByCarModelLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForeignForServiceByMonthByCarModel",
    },
    variables: {
      excel: { ...MONTH_CONTROL("groupReport"), car: true },
      table: { ...MONTH_CONTROL("groupReport"), car: true },
    },
    tableHasRefetchOnCompleted: true,
  },
  TOMonthOfControlCarFamilyRegion: {
    table: {
      hook: useGetCarForServiceByMonthByCarModelRegionLazyQuery,
      getterPath: "SRRGetter.getCarForServiceByMonthByCarModelRegion",
    },
    export: {
      hook: useGetReportReturnCarForServiceByMonthByCarModelRegionLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForServiceByMonthByCarModelRegion",
    },
    variables: {
      excel: { ...MONTH_CONTROL("groupReport"), car: true },
      table: { ...MONTH_CONTROL("groupReport"), car: true },
    },
    tableHasRefetchOnCompleted: true,
  },
  TOOwnBySalesPeriod: {
    table: {
      hook: useGetCarForServiceByPeriodLazyQuery,
      getterPath: "SRRGetter.getCarForServiceByPeriod",
    },
    export: {
      hook: useGetReportReturnCarForServiceByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForServiceByPeriod",
    },
    variables: {
      excel: SALES_PERIOD("groupReport"),
      table: SALES_PERIOD("group"),
    },
    tableHasRefetchOnCompleted: true,
  },
  TOFriendOrFoeBySalesPeriod: {
    table: {
      hook: useGetCarForeignForServiceByPeriodLazyQuery,
      getterPath: "SRRGetter.getCarForeignForServiceByPeriod",
    },
    export: {
      hook: useGetReportReturnCarForeignForServiceByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForeignForServiceByPeriod",
    },
    variables: {
      excel: SALES_PERIOD("groupReport"),
      table: SALES_PERIOD("group"),
    },
    tableHasRefetchOnCompleted: true,
  },
  TOFriendOrFoeByPeriodByCarFamily: {
    table: {
      hook: useGetCarForeignForServiceByPeriodByCarModelLazyQuery,
      getterPath: "SRRGetter.getCarForeignForServiceByPeriodByCarModel",
    },
    export: {
      hook: useGetReportReturnCarForeignForServiceByPeriodByCarModelLazyQuery,
      getterPath:
        "SRRGetter.reportReturnCarForeignForServiceByPeriodByCarModel",
    },
    variables: {
      excel: SALES_PERIOD("groupReport", true),
      table: SALES_PERIOD("group", true),
    },
    tableHasRefetchOnCompleted: true,
  },
  warrantyRepairMonthOfControl: {
    table: {
      hook: useGetReturnCarForAgoByMonthLazyQuery,
      getterPath: "SRRGetter.getCarForAGOByMonth",
    },
    export: {
      hook: useGetReportReturnCarForAgoByMonthLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForAGOByMonth",
    },
    variables: {
      excel: { ...MONTH_CONTROL("groupReport"), car: true, numberGO: true },
      table: {
        ...MONTH_CONTROL("groupReport"),
        car: true,
        numberGO: true,
        lifetime: true,
      },
    },
    tableHasRefetchOnCompleted: true,
  },
  warrantyRepairBySalesPeriod: {
    table: {
      hook: useGetReturnCarForeignForAgoByMonthLazyQuery,
      getterPath: "SRRGetter.getCarForeignForAGOByMonth",
    },
    export: {
      hook: useGetReportReturnCarForeignForAgoByMonthLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForeignForAGOByMonth",
    },
    variables: {
      excel: { ...MONTH_CONTROL("groupReport"), car: true, numberGO: true },
      table: {
        ...MONTH_CONTROL("groupReport"),
        car: true,
        numberGO: true,
        lifetime: true,
      },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnCarServiceDynamics: {
    table: {
      hook: useGetCarServiceDynamicsLazyQuery,
      getterPath: "SRRGetter.getCarServiceDynamics.data",
      defaultArray: true,
    },
    export: {
      hook: useGetReportReturnCarServiceDynamicsLazyQuery,
      getterPath: "SRRGetter.reportReturnCarServiceDynamics",
    },
    variables: { excel: PERIOD_GROUP, table: PERIOD_GROUP },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnCarServiceByDealer: {
    table: {
      hook: useGetCarServiceByDealerLazyQuery,
      getterPath: "SRRGetter.getCarServiceByDealer",
    },
    export: {
      hook: useGetReportReturnCarServiceByDealerLazyQuery,
      getterPath: "SRRGetter.reportReturnCarServiceByDealer",
    },
    variables: { excel: PERIOD_GROUP, table: PERIOD_GROUP },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnCarAverageDailyMileageByMonth: {
    table: {
      hook: useGetCarAverageDailyMileageByMonthLazyQuery,
      getterPath: "SRRGetter.getCarAverageDailyMileageByMonth",
    },
    export: {
      hook: useGetReportReturnCarAverageDailyMileageByMonthLazyQuery,
      getterPath: "SRRGetter.reportReturnCarAverageDailyMileageByMonth",
    },
    variables: {
      excel: { ...MONTH_CONTROL("groupReport"), familyCar: true },
      table: { ...MONTH_CONTROL("group"), familyCar: true },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnClientsWithoutService: {
    table: {
      hook: useGetClientsWithoutServiceLazyQuery,
      getterPath: "SRRGetter.getClientsWithoutService",
    },
    export: {
      hook: useGetReportReturnClientsWithoutServiceLazyQuery,
      getterPath: "SRRGetter.reportReturnClientsWithoutService",
    },
    variables: { excel: PERIOD_GROUP, table: PERIOD_GROUP },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnSRR3ByDealer: {
    table: {
      hook: useGetSrr3ByDealerLazyQuery,
      getterPath: "SRRGetter.getSRR3ByDealer",
      defaultArray: true,
    },
    export: {
      hook: useGetReportReturnSrr3ByDealerLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR3ByDealer",
    },
    variables: { excel: TC_MONTH, table: TC_MONTH },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnSRR3ByPeriod: {
    table: {
      hook: useGetSrr3ByPeriodLazyQuery,
      getterPath: "SRRGetter.getSRR3ByPeriod",
    },
    export: {
      hook: useGetReportReturnSrr3ByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR3ByPeriod",
    },
    variables: { excel: PERIOD_GROUP, table: PERIOD_GROUP },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnSRR3ForPayments: {
    table: {
      hook: useGetSrr3ForPaymentsLazyQuery,
      getterPath: "SRRGetter.getSRR3ForPayments",
    },
    export: {
      hook: useGetReportReturnSrr3ForPaymentsLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR3ForPayments",
    },
    variables: { excel: PERIOD_TC, table: PERIOD_TC },
    tableHasRefetchOnCompleted: true,
  },
  InvitationOfClientsForMaintenance: {
    table: {
      hook: useGetInviteClientToServiceLazyQuery,
      getterPath: "SRRGetter.getInviteClientToService",
    },
    export: {
      hook: useGetReportInviteClientToServiceLazyQuery,
      getterPath: "SRRGetter.reportInviteClientToService",
    },
    variables: {
      excel: { invitation: true, monthControl: true },
      table: { invitation: true, monthControl: true },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnSRR3ByCar: {
    table: {
      hook: useGetSrr3ByCarLazyQuery,
      getterPath: "SRRGetter.getSRR3ByCar",
    },
    export: {
      hook: useGetReportReturnSrr3ByCarLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR3ByCar",
    },
    variables: {
      excel: { ...PERIOD_TC, familyCar: true },
      table: { ...PERIOD_TC, familyCar: true },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnSRR3ByVIN: {
    table: {
      hook: useGetSrr3ByVinLazyQuery,
      getterPath: "SRRGetter.getSRR3ByVIN",
    },
    export: {
      hook: useGetReportReturnSrr3ByVinLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR3ByVIN",
    },
    variables: {
      excel: {
        typeClient: true,
        monthControl: true,
        dealerIdsKey: "dealerIds",
      },
      table: {
        typeClient: true,
        monthControl: true,
        dealerIdsKey: "dealerIds",
      },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnSRR5ByVIN: {
    table: {
      hook: useGetSrr5ByVinLazyQuery,
      getterPath: "SRRGetter.getSRR5ByVIN",
    },
    export: {
      hook: useGetReportReturnSrr5ByVinLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR5ByVIN",
    },
    variables: {
      excel: {
        typeClient: true,
        monthControl: true,
        dealerIdsKey: "dealerIds",
      },
      table: {
        typeClient: true,
        monthControl: true,
        dealerIdsKey: "dealerIds",
      },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnSRR5ByDealer: {
    table: {
      hook: useGetSrr5ByDealerLazyQuery,
      getterPath: "SRRGetter.getSRR5ByDealer",
    },
    export: {
      hook: useReportReturnSrr5ByDealerLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR5ByDealer",
    },
    variables: { excel: TC_MONTH, table: TC_MONTH },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnSRR5ByPeriod: {
    table: {
      hook: useGetSrr5ByPeriodLazyQuery,
      getterPath: "SRRGetter.getSRR5ByPeriod",
    },
    export: {
      hook: useGetReportReturnSrr5ByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR5ByPeriod",
    },
    variables: { excel: PERIOD_GROUP, table: PERIOD_GROUP },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnSRR5ForPayments: {
    table: {
      hook: useGetSrr5ForPaymentsLazyQuery,
      getterPath: "SRRGetter.getSRR5ForPayments",
    },
    export: {
      hook: useGetReportReturnSrr5ForPaymentsLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR5ForPayments",
    },
    variables: { excel: PERIOD_TC, table: PERIOD_TC },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnSRR5ByCar: {
    table: {
      hook: useGetSrr5ByCarLazyQuery,
      getterPath: "SRRGetter.getSRR5ByCar",
    },
    export: {
      hook: useGetReportReturnSrr5ByCarLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR5ByCar",
    },
    variables: {
      excel: { ...PERIOD_TC, familyCar: true },
      table: { ...PERIOD_TC, familyCar: true },
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnCarForServiceGIBDDByMonth: {
    table: {
      hook: useGetCarForServiceGibddByMonthLazyQuery,
      getterPath: "SRRGetter.getCarForServiceGIBDDByMonth",
    },
    export: {
      hook: useGetReportReturnCarForServiceGibddByMonthLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForServiceGIBDDByMonth",
    },
    variables: {
      excel: MONTH_CONTROL("groupReport"),
      table: MONTH_CONTROL("group"),
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnCarForServiceGIBDDByPeriod: {
    table: {
      hook: useGetCarForServiceGibddByPeriodLazyQuery,
      getterPath: "SRRGetter.getCarForServiceGIBDDByPeriod",
    },
    export: {
      hook: useGetReportReturnCarForServiceGibddByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForServiceGIBDDByPeriod",
    },
    variables: {
      excel: SALES_PERIOD("groupReport"),
      table: SALES_PERIOD("group"),
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnCarForeignForServiceGIBDDByMonth: {
    table: {
      hook: useGetCarForeignForServiceGibddByMonthLazyQuery,
      getterPath: "SRRGetter.getCarForeignForServiceGIBDDByMonth",
    },
    export: {
      hook: useGetReportReturnCarForeignForServiceGibddByMonthLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForeignForServiceGIBDDByMonth",
    },
    variables: {
      excel: MONTH_CONTROL("groupReport"),
      table: MONTH_CONTROL("group"),
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnCarForeignForServiceGIBDDByPeriod: {
    table: {
      hook: useGetCarForeignForServiceGibddByPeriodLazyQuery,
      getterPath: "SRRGetter.getCarForeignForServiceGIBDDByPeriod",
    },
    export: {
      hook: useGetReportReturnCarForeignForServiceGibddByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForeignForServiceGIBDDByPeriod",
    },
    variables: {
      excel: SALES_PERIOD("groupReport"),
      table: SALES_PERIOD("group"),
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnSRR3GIBDDByDealer: {
    table: {
      hook: useGetSrr3GibddByDealerLazyQuery,
      getterPath: "SRRGetter.getSRR3GIBDDByDealer",
    },
    export: {
      hook: useReportReturnSrr3GibddByDealerLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR3GIBDDByDealer",
    },
    variables: { excel: TC_MONTH, table: TC_MONTH },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnSRR5GIBDDByDealer: {
    table: {
      hook: useGetSrr5GibddByDealerLazyQuery,
      getterPath: "SRRGetter.getSRR5GIBDDByDealer",
    },
    export: {
      hook: useReportReturnSrr5GibddByDealerLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR5GIBDDByDealer",
    },
    variables: { excel: TC_MONTH, table: TC_MONTH },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnSRR3GIBDDByPeriod: {
    table: {
      hook: useGetSrr3GibddByPeriodLazyQuery,
      getterPath: "SRRGetter.getSRR3GIBDDByPeriod",
    },
    export: {
      hook: useReportReturnSrr3GibddByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR3GIBDDByPeriod",
    },
    variables: { excel: PERIOD_GROUP, table: PERIOD_GROUP },
    tableHasRefetchOnCompleted: false,
  },
  ReportReturnSRR5GIBDDByPeriod: {
    table: {
      hook: useGetSrr5GibddByPeriodLazyQuery,
      getterPath: "SRRGetter.getSRR5GIBDDByPeriod",
    },
    export: {
      hook: useReportReturnSrr5GibddByPeriodLazyQuery,
      getterPath: "SRRGetter.reportReturnSRR5GIBDDByPeriod",
    },
    variables: { excel: PERIOD_GROUP, table: PERIOD_GROUP },
    tableHasRefetchOnCompleted: false,
  },
  TOReturnCarForServiceByPeriodConsolidated: {
    table: {
      hook: useGetCarForServiceByPeriodConsolidatedLazyQuery,
      getterPath: "SRRGetter.getCarForServiceByPeriodConsolidated.sales",
      defaultArray: true,
    },
    export: {
      hook: useGetReportReturnCarForServiceByPeriodConsolidatedLazyQuery,
      getterPath: "SRRGetter.reportReturnCarForServiceByPeriodConsolidated",
    },
    variables: {
      excel: SALES_PERIOD("group", true),
      table: SALES_PERIOD("group", true),
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportNSByDealer: {
    table: {
      hook: useGetNsByDealerLazyQuery,
      getterPath: "SRRGetter.getNSByDealer",
    },
    export: {
      hook: useReportNsByDealerLazyQuery,
      getterPath: "SRRGetter.reportNSByDealer",
    },
    variables: {
      excel: { ...PERIOD_GROUP, familyCar: true, nsDealerExtras: true },
      table: { ...PERIOD_GROUP, familyCar: true, nsDealerExtras: true },
    },
    tableHasRefetchOnCompleted: false,
  },
  ReportNSByConsultant: {
    table: {
      hook: useGetNsByConsultantLazyQuery,
      getterPath: "SRRGetter.getNSByConsultant",
    },
    export: {
      hook: useReportNsByConsultantLazyQuery,
      getterPath: "SRRGetter.reportNSByConsultant",
    },
    variables: { excel: NS_EXTRAS, table: NS_EXTRAS },
    tableHasRefetchOnCompleted: false,
  },
  ReportNSByClient: {
    table: {
      hook: useGetNsByClientLazyQuery,
      getterPath: "SRRGetter.getNSByClient",
    },
    export: {
      hook: useReportNsByClientLazyQuery,
      getterPath: "SRRGetter.reportNSByClient",
    },
    variables: { excel: NS_EXTRAS, table: NS_EXTRAS },
    tableHasRefetchOnCompleted: false,
  },
  ReportNSByWarmClients: {
    table: {
      hook: useGetNsByWarmClientsLazyQuery,
      getterPath: "SRRGetter.getNSByWarmClients",
    },
    export: {
      hook: useReportNsByWarmClientsLazyQuery,
      getterPath: "SRRGetter.reportNSByWarmClients",
    },
    variables: { excel: NS_EXTRAS, table: NS_EXTRAS },
    tableHasRefetchOnCompleted: false,
  },
  ReportNSByOldClients: {
    table: {
      hook: useGetNsByOldClientsLazyQuery,
      getterPath: "SRRGetter.getNSByOldClients",
    },
    export: {
      hook: useReportNsByOldClientsLazyQuery,
      getterPath: "SRRGetter.reportNSByOldClients",
    },
    variables: { excel: NS_EXTRAS, table: NS_EXTRAS },
    tableHasRefetchOnCompleted: false,
  },
  ReportNSByAverageCarAge: {
    table: {
      hook: useGetNsByAverageCarAgeLazyQuery,
      getterPath: "SRRGetter.getNSByAverageCarAge",
    },
    export: {
      hook: useReportNsByAverageCarAgeLazyQuery,
      getterPath: "SRRGetter.reportNSByAverageCarAge",
    },
    variables: {
      excel: {
        dealerIdsKey: "DealerIds",
        periodRange: "period",
        familyCar: true,
      },
      table: {
        dealerIdsKey: "DealerIds",
        periodRange: "period",
        familyCar: true,
      },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportNSByClientCarSale: {
    table: {
      hook: useGetNsByClientCarSaleLazyQuery,
      getterPath: "SRRGetter.getNSByClientCarSale",
    },
    export: {
      hook: useReportNsByClientCarSaleLazyQuery,
      getterPath: "SRRGetter.reportNSByClientCarSale",
    },
    variables: { excel: NS_EXTRAS, table: NS_EXTRAS },
    tableHasRefetchOnCompleted: true,
  },
  ReportAverageReceiptTO: {
    table: {
      hook: useGetAverageReceiptToLazyQuery,
      getterPath: "SRRGetter.getAverageReceiptTO",
    },
    export: {
      hook: useReportAverageReceiptToLazyQuery,
      getterPath: "SRRGetter.reportAverageReceiptTO",
    },
    variables: {
      excel: { baseFrom: true, periodRange: "period", groupKey: "group" },
      table: { baseFrom: true, periodRange: "period", groupKey: "group" },
    },
    tableHasRefetchOnCompleted: true,
  },
  ReportReturnAverageReceiptAKC: {
    table: {
      hook: useGetAverageReceiptAkcLazyQuery,
      getterPath: "SRRGetter.getAverageReceiptAKC",
    },
    export: {
      hook: useReportAverageReceiptAkcLazyQuery,
      getterPath: "SRRGetter.reportAverageReceiptAKC",
    },
    variables: {
      excel: { baseFrom: true, periodRange: "period", groupKey: "group" },
      table: { baseFrom: true, periodRange: "period", groupKey: "group" },
    },
    tableHasRefetchOnCompleted: true,
  },
};
